// Where an order originated. Values match the backend OrderSource enum / morph
// aliases so they round-trip through source_type unchanged. A manual order has
// no origin entity: it is stored as a null source_type and shown as "Manual".
export enum OriginType {
  ticket = "ticket",
  call_history = "call_history",
  lead = "lead",
  opportunity = "opportunity",
}

export const OriginTypeLabel: Record<OriginType, string> = {
  [OriginType.ticket]: "Ticket",
  [OriginType.call_history]: "Call History",
  [OriginType.lead]: "Lead",
  [OriginType.opportunity]: "Opportunity",
};

// Shown when an order has no source (source_type === null).
export const MANUAL_SOURCE_LABEL = "Manual";
